<flo-modal [active]="isExpanded$ | async" [width]="600" (isActive)="closeModal()">
  <div class="view-as-widget">
    
    <!-- Warning Phase - only show if not already viewing as user -->
    <div *ngIf="!(hasAcknowledged$ | async) && !(isViewingAsUser$ | async)">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h2>⚠️ Admin View-As Mode</h2>
      </div>
      <div class="warning-content">
        <div class="alert alert-warning">
          <strong>Important:</strong> You are about to view the application as another user. 
          This will allow you to see and potentially modify <strong>real customer data</strong>.
        </div>
        <ul class="warning-list">
          <li>You will have access to the selected user's account and data</li>
          <li>Any actions you take will be performed as that user</li>
          <li>This should only be used for legitimate support purposes</li>
          <li>All activity may be logged and monitored</li>
        </ul>
        <div class="mt-3">
          <p><strong>Do you understand and wish to continue?</strong></p>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-4">
        <button class="btn btn-secondary me-2" (click)="closeModal()">
          Cancel
        </button>
        <button class="btn btn-primary" (click)="onAcknowledgeWarning()">
          I Understand - Continue
        </button>
      </div>
    </div>

    <!-- Form Phase - show when acknowledged or when currently viewing as user -->
    <div *ngIf="(hasAcknowledged$ | async) || (isViewingAsUser$ | async)">
      
      <!-- New User Input Form -->
      <div *ngIf="!(isViewingAsUser$ | async)">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h2>View As User</h2>
        </div>
        <div class="form-group">
          <label for="viewAsInput" class="form-label">User Email or ID</label>
          <input 
            id="viewAsInput"
            placeholder="Enter user email or user ID" 
            [formControl]="viewAsUserControl"
            class="form-control"
          />
          <div *ngIf="viewAsError$ | async as error" class="text-danger small mt-1">
            {{ error }}
          </div>
        </div>
        <div class="d-flex justify-content-end mt-4">
          <button class="btn btn-secondary me-2" (click)="closeModal()">
            Cancel
          </button>
          <button 
            class="btn btn-primary"
            (click)="viewAsUser()"
            [disabled]="!viewAsUserControl.value?.trim()"
          >
            View As User
          </button>
        </div>
      </div>

      <!-- Current User Display -->
      <div *ngIf="isViewingAsUser$ | async" class="current-view-as">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h2>Exit View-As Mode</h2>
        </div>
        <div class="alert alert-info">
          <strong>Currently viewing as:</strong>
          <div *ngIf="viewedUserInfo$ | async as userInfo" class="mt-2">
            <strong>{{ userInfo.name || userInfo.email }}</strong>
            <span *ngIf="userInfo.name" class="text-muted d-block">({{ userInfo.email }})</span>
            <span class="text-muted d-block">ID: {{ userInfo.id }}</span>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-4">
          <button class="btn btn-secondary me-2" (click)="closeModal()">
            Close
          </button>
          <button 
            class="btn btn-danger"
            (click)="stopViewingAsUser()"
          >
            Stop Viewing As User
          </button>
        </div>
      </div>
    </div>

  </div>
</flo-modal>
